// A partner center admin only ever works inside their own center, so their urls say which
// one: /admin/culinary-and-hospitality-academy instead of the shared /admin/students. The
// slug is derived from the center name the backend already stores on the admin, so nothing
// extra has to be persisted for the url to stay stable across logins.

export const STUDENTS_PATH = "/admin/students";

export const centerSlug = (centerName) =>
  (centerName || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Where a given admin's student list lives. "None" is what a full administrator is stored
// under, so it is not a center and falls back to the shared url - as does an administrator
// or a partner center admin whose center name is missing.
export const centerStudentsPath = (admin) => {
  if (admin?.role !== "PartnerCenter") return STUDENTS_PATH;

  const slug = centerSlug(admin.partnerTrainingCenter);
  if (!slug || slug === "none") return STUDENTS_PATH;

  return `/admin/${slug}`;
};

// True when the admin has a center-scoped url of their own, i.e. /admin/students should
// send them onwards rather than render.
export const hasCenterPath = (admin) => centerStudentsPath(admin) !== STUDENTS_PATH;

// Where an admin lands right after logging in: administrators on the admin roster, partner
// centers on their own center's students.
export const adminLandingPath = (admin) =>
  admin?.role === "Administrator" ? "/admin" : centerStudentsPath(admin);
